export const floatingActions = {
	massEdit: "Edição em massa de produtos",
	editExcel: "Importar via Excel",
	testFiscal: "Testar integração fiscal",
	testFiscalData: "Testar dados fiscais",
	syncWithDelivery: "Sincronizar com delivery",
	deleteSelected: "Excluir produtos selecionados",
};
